/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbClauseMetiersLiesDto
 */
export interface FcbClauseMetiersLiesDto {
    /**
     * 
     * @type {number}
     * @memberof FcbClauseMetiersLiesDto
     */
    idClause?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof FcbClauseMetiersLiesDto
     */
    idMetiers?: Array<number> | null;
}

/**
 * Check if a given object implements the FcbClauseMetiersLiesDto interface.
 */
export function instanceOfFcbClauseMetiersLiesDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbClauseMetiersLiesDtoFromJSON(json: any): FcbClauseMetiersLiesDto {
    return FcbClauseMetiersLiesDtoFromJSONTyped(json, false);
}

export function FcbClauseMetiersLiesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbClauseMetiersLiesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idClause': !exists(json, 'idClause') ? undefined : json['idClause'],
        'idMetiers': !exists(json, 'idMetiers') ? undefined : json['idMetiers'],
    };
}

export function FcbClauseMetiersLiesDtoToJSON(value?: FcbClauseMetiersLiesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idClause': value.idClause,
        'idMetiers': value.idMetiers,
    };
}

